export default __webpack_public_path__ + "static/media/Bullet 04.697754dd.webp";